import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, DealDTO, Pagination, SSPContractDTO } from '../../services/api/api';
import { BehaviorSubject } from 'rxjs';
import { ModalNavigationService } from '../../services/gui/modal/modal-navigation.service';
import { UtilService } from '../../services/util.service';
import { ErrorService } from '../../services/error.service';
import { PermissionService } from '../../services/permission.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-comp-deal-creation',
  templateUrl: './deal-creation.component.html',
  styleUrls: ['./deal-creation.component.scss'],
  standalone: false,
})
export class DealCreationComponent implements OnInit {
  deal: DealDTO;
  sspContracts: SSPContractDTO[];
  sspContract: SSPContractDTO;
  paginationSSPContracts: BehaviorSubject<Pagination>;
  identifier: string;
  name: string;
  editMode: boolean;

  constructor(
    private api: API,
    private modalNavigation: ModalNavigationService,
    public util: UtilService,
    private errorHandler: ErrorService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.editMode = false;
    this.name = '';
    this.deal = undefined;
    this.sspContracts = undefined;
    this.sspContract = null;
    this.identifier = '';
    this.paginationSSPContracts = new BehaviorSubject<Pagination>({ page: 1, count: 99, pages: -1, resultcount: -1 });
  }

  ngOnInit(): void {
    this.api
      .shared_SSPContract_retrieveAll({}, this.paginationSSPContracts)
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: (receivedSSPContracts: SSPContractDTO[]) => {
          this.sspContracts = receivedSSPContracts;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
    if (this.modalNavigation.getCurrentNavigation().data) {
      const modalData = this.modalNavigation.getCurrentNavigation().data;
      if (modalData.useParamData) {
        if (modalData.editMode) {
          this.deal = modalData.deal;
          this.sspContract = modalData.deal.sspContract;
          this.identifier = modalData.deal.identifier;
          this.name = modalData.deal.name;
          this.editMode = true;
        } else {
          this.sspContract = modalData.sspContract;
          this.editMode = false;
        }
      }
    }
  }

  onIdentifier($event: string) {
    if ($event && $event.length > 0) {
      this.identifier = $event;
    } else {
      this.identifier = null;
    }
  }

  onName($event: string) {
    if ($event && $event.length > 0) {
      this.name = $event;
    } else {
      this.name = null;
    }
  }

  getSSPContractText(): string {
    if (this.sspContract) {
      if (this.sspContract.name && this.sspContract.identifier) {
        return this.sspContract.name + '(' + this.sspContract.identifier + ')';
      } else {
        if (this.sspContract.name) {
          return this.sspContract.name;
        }
        if (this.sspContract.identifier) {
          return this.sspContract.identifier;
        }
      }
    }
    return 'n. def.';
  }

  setSSPContract(sspContract: SSPContractDTO) {
    this.sspContract = sspContract;
  }

  ok() {
    if (!this.editMode) {
      this.deal = new DealDTO();
      this.deal.identifier = this.identifier;
      this.deal.name = this.name;
      this.api
        .shared_SSPContract_createDeal(this.sspContract.id, this.deal)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: (receivedDeal: DealDTO) => {
            this.close(receivedDeal);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    } else {
      this.deal.identifier = this.identifier;
      this.deal.name = this.name;
      this.api
        .shared_Deal_editDeal(this.deal)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: (receivedDeal: DealDTO) => {
            this.close(receivedDeal);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  close(data) {
    this.modalNavigation.result(data);
  }

  cancel() {
    this.close(null);
  }
}
